import Currency from "./Currency";
import Number from "./Number";
import Percent from "./Percent";
import Link from "./Link";

export default { Currency, Number, Percent, Link };
